import API from "./authApi";

export const createSchool = async (
  schoolData
) => {
  const response =
    await API.post(
      "/school/create",
      schoolData
    );

  return response.data;
};

export const getMySchool =
  async () => {
    const response =
      await API.get(
        "/school/me"
      );

    return response.data;
  };

// Accepts a FormData instance (schoolName, mobile, address, and optionally
// a "logo" file field) so the logo upload can go through in the same request.
export const updateSchool = async (
  schoolData
) => {
  const isFormData =
    schoolData instanceof FormData;

  const response =
    await API.put(
      "/school/me",
      schoolData,
      {
        headers: isFormData
          ? {
              "Content-Type":
                "multipart/form-data",
            }
          : undefined,
      }
    );

  return response.data;
};

export const deleteSchool =
  async () => {
    const response =
      await API.delete(
        "/school/me"
      );

    return response.data;
  };